import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Icon from './forms/Icon';
import { useGlobalState } from './stateProvider/StateProvider';
import Col from './layout/Col';
import Heading from './forms/Heading';
import LinkTo from './forms/LinkTo';
import Row from './layout/Row';

const Wrapper = styled.div`
    position: relative;
    color: ${({ theme }) => theme.text};
`
const LinkWrapper = styled(Col)`
    position: absolute;
    z-index: 10;
    margin-top: 0.5em;

    padding: 0.3em 0.5em;
    width: fit-content;
    border-radius: 0.25em;
    background: ${({ theme }) => theme.background};
    box-shadow: 2px 2px 5px 2px ${({ theme }) => theme.shadow};

    min-width: 15em;
    
    animation: slideIn 0.2s;
`
const QuickLink = styled(Row)`
    cursor: pointer;
    
    white-space: nowrap;

    display: flex;
    gap: 0.5em;
    align-items: center;
    transition: all 0.2s;

    &:hover {
        margin-left: 0.2em;
    }
`
const FavIcon = styled(Icon)`
    color: ${({ fav, theme }) => fav ? theme.secondary : theme.text};
    opacity: ${({ fav }) => fav ? 1 : 0.2};
    cursor: pointer;
`;

const QuickMenu = ({ color, ...props }) => {
    const {
        state: {
            quick_menu,
        },
        updateQuickMenu,
    } = useGlobalState();

    const [showing, setShowing] = useState(false)

    useEffect(() => {
        const handleClickOutsideFav = () => setShowing(false);
        document.addEventListener('click', handleClickOutsideFav);
        return () => document.removeEventListener('click', handleClickOutsideFav);
    }, [showing]);

    return (
        <Wrapper>
            <Row
                onClick={(e) => {
                    e.stopPropagation();
                    setShowing(!showing);
                }}
                id='QuixLinx'
            >
                <FavIcon
                    fav={quick_menu.length}
                    icon='star'
                    title='Quick Links'
                />
                <Heading>Quick Links</Heading>
            </Row>

            {showing ? (
                <LinkWrapper>
                    <Heading style={{ whiteSpace: 'nowrap' }}>
                        <Icon icon='link' />
                    </Heading>
                    {quick_menu.map(e => (
                        <QuickLink>
                            <Icon
                                icon='cross'
                                onClick={(f) => {
                                    f.stopPropagation();
                                    updateQuickMenu(e.route, e.label, quick_menu)
                                }}
                            />
                            <LinkTo
                                to={e.route}
                                onClick={() => setShowing(!showing)}
                            >{e.label}</LinkTo>

                        </QuickLink>
                    ))}

                    {!quick_menu.length && (
                        <span>
                            Click the <Icon icon='star' /> on Pages to add a Quick Link!
                        </span>
                    )}
                </LinkWrapper>
            ) : null}
        </Wrapper>
    );
}

export default QuickMenu;